'use client';

import React from 'react';
import { DynamicField } from '@/components/dynamic-field/DynamicField';
import { FormSubmitButton } from '@/components/forms/form-submit-button/FormSubmitButton';
import { FieldValues, useForm, UseFormReset, UseFormSetError } from 'react-hook-form';
import { ISchema } from '@/services/formSchema.service';
import { useScrollToError } from '@/hooks/useScrollToError';

interface DynamicForm {
    formSchema: ISchema[];
    element?: React.ReactElement;
    cancelButton?: React.ReactElement;
    omitSubmitButtonMargin?: boolean;
    isSubmitButtonDisabled?: boolean;
    formSubmitButtonLabel: string;
    onFormSubmit(data: FieldValues, setError: UseFormSetError<any>, reset?: UseFormReset<any>): void;
}

export const DynamicForm: React.FC<DynamicForm> = ({
    formSchema,
    formSubmitButtonLabel,
    element,
    onFormSubmit,
    omitSubmitButtonMargin,
    cancelButton,
    isSubmitButtonDisabled,
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid, isSubmitting },
        setValue,
        control,
        watch,
        setError,
        reset,
    } = useForm<FieldValues>({ mode: 'onTouched' });

    useScrollToError(isValid, isSubmitting);

    return (
        <form noValidate={true} onSubmit={handleSubmit((data) => onFormSubmit(data, setError, reset))}>
            {formSchema.map((item) => (
                <DynamicField
                    validation={item.validation}
                    fieldName={item.fieldName}
                    key={item.fieldName}
                    fieldType={item.fieldType}
                    errors={errors}
                    formValues={control._formValues}
                    setValue={setValue}
                    control={control}
                    initialValue={item.initialValue}
                    fieldProperties={item.properties}
                    register={register}
                    watch={watch}
                />
            ))}
            {element}
            <FormSubmitButton
                label={formSubmitButtonLabel}
                omitSubmitButtonMargin={omitSubmitButtonMargin}
                isSubmitButtonDisabled={isSubmitButtonDisabled}
            />
            {cancelButton}
        </form>
    );
};
